import { connect } from 'react-redux';

import { AdFoxBannerTracker } from './tracker';
import { IWithTrackingProps } from '../../../hoc/withTracking';
import { IAppState } from '../../../../common/state';
import { prepareTrackingData } from '../../../../utils/prepareTrackingData';
import { shouldSendAdsEvent } from '../../../../utils/shouldSendAdsEvent';

export function mapStateToProps(state: IAppState): IWithTrackingProps {
  const { filters, results, userGADataLayerData, breadcrumbs } = state;

  return {
    tracking: prepareTrackingData(filters, results, breadcrumbs, userGADataLayerData),
    shouldSendAdsEvent: shouldSendAdsEvent(filters.jsonQuery),
  };
}

export const AdFoxBannerTrackerContainer = connect<IWithTrackingProps>(mapStateToProps)(AdFoxBannerTracker);
